import { default as BodyComponent } from './BodyComponent';

export { BodyComponent };
